var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRupiniconnew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_731_9181)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.038 14.2008H11.5518L1.45935 0.650391H18.038C21.7825 0.650391 24.8157 3.68355 24.8157 7.42807C24.8157 11.1677 21.7825 14.2008 18.038 14.2008Z",
    fill: "#334155"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.45935 14.1992L9.63011 25.3488H24.9491L16.4918 14.1992H1.45935Z",
    fill: "#334155"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_731_9181"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRupiniconnew);
export default __webpack_public_path__ + "static/media/rupiniconnew.3f7b6ea085b1026fb1c31091aa1786fc.svg";
export { ForwardRef as ReactComponent };